import { Image } from "@heroui/image";
import React from "react";

import { About3 } from "@/public/assets";

const WhatMakesUsDifferent = () => {
  return (
    <section className="lg:px-28 px-4 pt-14 max-w-screen-2xl mx-auto py-14">
      <div>
        <div className="text-primary text-sm font-medium leading-4 text-center mb-6">
          What makes us different
        </div>
        <div className="text-center max-w-md mb-4 mx-auto text-2xl font-medium w-full leading-8">
          We don’t overwhelm you with options, we bring you the right ones.
        </div>
        <div className="text-neutral-500 text-base font-normal max-w-3xl mx-auto leading-6 tracking-[-0.176px] text-center mb-9">
          Our process is designed to reduce hiring risk, save time, and improve
          the quality of every decision you make. From entry-level roles to
          specialized positions, we focus on getting it right the first time.
        </div>
        <Image
          removeWrapper
          alt="img 44"
          className="object-cover rounded-[32px] max-w-5xl h-[50vh] w-full mx-auto object-[50%_7%]"
          src={About3.src}
        />
      </div>
    </section>
  );
};

export default WhatMakesUsDifferent;
